import { Link } from "react-router-dom";
import { SlidersHorizontal } from "lucide-react";
import { filterSummary, isEmptyFilter, useGenres } from "@/components/FilterEditor";
import { useProviders } from "@/components/WatchFilter";

const LABEL = { default: "default preferences", mood: "current mood", all: "nothing (showing everything)" };

const Action = ({ onClick, children, testId }) => (
  <button onClick={onClick} data-testid={testId}
    className="h-9 px-4 rounded-full border text-xs font-bold bg-background hover:bg-accent transition-colors">{children}</button>
);

export function WatchlistFilterBanner({ data, onView }) {
  const genres = useGenres();
  useProviders();
  const { filter, view, active_profile: active, total, items } = data;
  const isMood = filter.profile === "mood";
  const filtered = !isEmptyFilter(filter);
  return (
    <div data-testid="watchlist-filter-banner" data-filter-profile={filter.profile}
      className={`mb-8 rounded-3xl border p-5 flex flex-col md:flex-row md:items-center justify-between gap-4 fade-up ${isMood ? "border-primary/50 bg-primary/5" : "bg-card"}`}>
      <div className="flex items-start gap-3 min-w-0">
        <SlidersHorizontal className={`h-5 w-5 mt-0.5 shrink-0 ${isMood ? "text-primary" : "text-muted-foreground"}`} />
        <div className="min-w-0">
          <p className="font-semibold" data-testid="watchlist-filter-title">
            {filtered ? <>Filtered by your <span className={isMood ? "text-primary" : ""}>{LABEL[filter.profile]}</span></> : `Showing everything`}
            {view !== "active" && <span className="text-muted-foreground font-normal"> · preview, not your active setting</span>}
          </p>
          {filtered && <p className="text-sm text-muted-foreground truncate" data-testid="watchlist-filter-summary">{filterSummary(filter, genres)}</p>}
          <p className="text-xs text-muted-foreground mt-1" data-testid="watchlist-filter-count">Showing {items.length} of {total} movies</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {active === "mood" && view !== "default" && <Action onClick={() => onView("default")} testId="watchlist-view-default">View with default preferences</Action>}
        {view !== "active" && <Action onClick={() => onView("active")} testId="watchlist-view-active">Back to {LABEL[active]}</Action>}
        {view !== "all" && filtered && <Action onClick={() => onView("all")} testId="watchlist-view-all">Show all</Action>}
        <Link to="/genres" data-testid="watchlist-edit-filter" className="h-9 px-4 rounded-full text-xs font-bold text-primary flex items-center hover:underline">Edit filter</Link>
      </div>
    </div>
  );
}
